module.exports = __webpack_public_path__ + "img/sindrome_o_que_e.7cb03008.jpg";